import $ from "jquery";
import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://bb35493c00d3bc376ab9ece7e03ca2de@sentry.open3dlab.com/3",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  profilesSampleRate: 0.3,
  tracesSampleRate: 0.1,
});

function adsBlocked(callback){
    var testURL = 'https://poweredby.jads.co/js/jads2.js'

    var myInit = {
        method: 'HEAD',
        mode: 'no-cors'
    };

    var myRequest = new Request(testURL, myInit);

    fetch(myRequest).then(function(response) {
        return response;
    }).then(function(response) {
        callback(false);
    }).catch(function(e){
        callback(true);
    });
}

document.addEventListener("DOMContentLoaded", function(event) {
    if (document.getElementById('gxXZxboDnD')) {
        adsBlocked(function(blocked){
            if(blocked){
                let adcontainer = document.getElementById('gxXZxboDnD');
                adcontainer.removeAttribute('id')
                adcontainer.classList.add('content-container')
                let linkElement = document.createElement('a');
                let imageElement = document.createElement('img');
                let urlAttribute = document.createAttribute("href");
                let srcAttribute = document.createAttribute("src");
                urlAttribute.value = "https://www.patreon.com/sfmlab";
                srcAttribute.value = "https://s3.eu-central-1.wasabisys.com/open3dlab-static/img/patreon.png";
                linkElement.setAttributeNode(urlAttribute);
                imageElement.setAttributeNode(srcAttribute);
                linkElement.append(imageElement);
                adcontainer.append(linkElement);
                adcontainer.style.justifyContent = 'center';
            }
        });
    }
    if (document.getElementById('js-mainnav-collapsable')) {
        $('#js-mainnav-collapsable').on('click', function(){
            $('#js-mainnav-container').toggleClass('nav-list__item--hidden');
        });
    }
    if (document.getElementById('js-subnav-collapsable')) {
        $('#js-subnav-collapsable').on('click', function(){
            $('#js-subnav-container').toggleClass('nav-list__item--hidden');
        });
    }
    if (document.getElementById('js-sites-collapsable')) {
        $('#js-sites-collapsable').on('click', function(){
            $('#js-sites-container').toggleClass('nav-list__item--hidden');
        });
    }

    var expandedSearchButton = document.getElementById("js-search-options__expand");
    if (expandedSearchButton) {
      expandedSearchButton.addEventListener(
      "click",
        function(event) {
          var expandedSearchElement = document.getElementById("js-search-options__full");
          if (expandedSearchElement){
            expandedSearchElement.classList.toggle('search-options__full--expanded')
          }
        }
      );
    }

    var orderBySelectionBox = document.getElementById("id_order_by");
    if (orderBySelectionBox) {
        orderBySelectionBox.addEventListener("change", function(event) {
            event.target.form.submit();
        });
    }

    // Attempt to block NordVPN's odd 404 requests to keep sessions alive.
    // Basically run every 30 seconds and if the sessionURL is set, set it to a deadend URL
    // https://security.stackexchange.com/questions/277353/odd-repetitive-16character-404-web-requests-with-json-refreshttl-payload
    setInterval(function() {
        if (typeof window.JCosmeticSession !== 'undefined') { window.sessionURL = 'http://127.0.0.1/deadend'; }
    }, 30000);
});